import './acl';
import './init/rule-condition.decorator';

Shopware.Component.override('sw-settings-rule-detail-assignments', () => import('./view/sw-settings-rule-detail-assignments'));
